import { Badge, cn } from '@rematter/ui-web';

type BrokeredOrderBadgeProps = {
  orderNumber: string;
  size?: 'small' | 'xs' | 'default' | 'large';
  className?: string;
};

export const BrokeredOrderBadge = ({
  orderNumber,
  size = 'small',
  className,
}: BrokeredOrderBadgeProps) => (
  <Badge
    color="primary"
    size={size}
    className={cn('@BrokeredOrderBadge', className)}
  >
    {orderNumber}
  </Badge>
);

type SalesOrderBadgeProps = {
  orderNumber: string;
  size?: 'small' | 'xs' | 'default' | 'large';
  className?: string;
};

export const SalesOrderBadge = ({
  orderNumber,
  size = 'small',
  className,
}: SalesOrderBadgeProps) => (
  <Badge
    color="success"
    size={size}
    className={cn('@SalesOrderBadge', className)}
  >
    {orderNumber}
  </Badge>
);
